export default __webpack_public_path__ + "static/10-4--e850b7d5a6ca3173d468216b8a74a1df.png";